// extracted by mini-css-extract-plugin
export default {"Slides":"carousel_Slides__m5FS1"};